import { elementSizeCssClass, large } from "../size/index.js";
import defineElementWithNoChild from "../helpers/defineElementWithNoChild.js";

/**
 * Spinning circle. Usually used to indicate that something is happening.
 *
 * @param {object} [options]
 * @param {ElementSize} [options.size] - Size of the spinning circle
 */
export default defineElementWithNoChild("spinner", ({ size = large }) => ({
	options: { class: elementSizeCssClass("size", size) },
	children: (html) => {
		html.div();
		html.div();
		html.div();
		html.div();
	},
}));
